import { constants as Input } from '../Input';
import { constants as Label } from '../Label';
import { constants as InlineMessage } from '../InlineMessage';
import { VARIANT_DEFAULT, ELEMENT_LABEL, ELEMENT_INPUT, ELEMENT_INLINE_MESSAGE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, DATA_STATE_INVALID, DATA_STATE_VALID, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Textarea',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_INPUT,
        ELEMENT_INLINE_MESSAGE,
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getTextarea() {
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM,
                    },
                },
            },
            [ELEMENT_INPUT]: {
                components: {
                    [Input.NAME]: {
                        variant: Input.variants.VARIANT_MULTILINE,
                    },
                },
            },
            [ELEMENT_INLINE_MESSAGE]: {
                components: {
                    [InlineMessage.NAME]: {
                        variant: InlineMessage.variants.VARIANT_DEFAULT,
                    },
                },
            },
        },
    });
}
